import { render } from "./App.vue?vue&type=template&id=f035454c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=f035454c&lang=css"

import exportComponent from "/Users/abiinteriors/Documents/WorkSpace/abi-content-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__